import React from 'react';

export default function CustomNoRowsOverlay() {
  return <div>There were no results that matched your criteria.</div>;
}
